<template>
    <v-app-bar
        absolute
        dense
        :elevation="4"
        :class="$vuetify.theme.dark == false ? 'd-print-none fix-appbar-2' : ''"
        :style="$vuetify.theme.dark == true ? 'background-color:#0F1D25' : ''"
    >
        <v-app-bar-nav-icon @click="changeMutate"></v-app-bar-nav-icon>

        <!-- <v-toolbar-title>Page title</v-toolbar-title> -->
        <!-- <v-switch
            class="mt-5"
            v-model="chk_color_bar"
            @change="func_chk_color_bar()"
        ></v-switch> -->
        <!-- <v-spacer></v-spacer> -->
        <!-- <v-btn fab text small class="mr-1" @click="change_theme()">
            <v-icon v-if="$vuetify.theme.dark == true" color="cyan accent-2"
                >mdi-weather-night
            </v-icon>
            <v-icon v-if="$vuetify.theme.dark == false" color="amber"
                >mdi-white-balance-sunny
            </v-icon>
        </v-btn> -->

        <v-row justify="end">
            <v-col cols="12" sm="7" md="4" lg="3">
                <!-- <v-text-field
                    color=""
                    @keyup="check_search_case()"
                    v-model="form.search_case"
                    class="pt-6"
                    label="Search"
                    prepend-inner-icon="mdi-magnify"
                    single-line
                    solo-inverted
                    rounded
                    dense
                ></v-text-field> -->
                <!-- @keyup="check_search_case()" -->
                <v-text-field
                    @keyup.enter="check_search_case()"
                    v-model="form.search_case"
                    color="info darken"
                    placeholder="Start typing... / Enter"
                    prepend-inner-icon="mdi-magnify"
                    single-line
                    solo-inverted
                    rounded
                    dense
                    loading
                    class="pt-6"
                >
                    <template v-slot:progress>
                        <v-progress-linear
                            v-if="custom"
                            :value="progress"
                            :color="color"
                            absolute
                            height="7"
                        ></v-progress-linear>
                    </template>
                </v-text-field>
            </v-col>
        </v-row>

        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- 
        <v-badge
            :content="numAlert"
            :value="numAlert"
            color="red"
            offset-x="23"
            offset-y="23"
        >
            <v-btn icon>
                <v-icon>mdi-heart</v-icon>
            </v-btn>
    </v-badge>-->

        <!-- <v-menu
            bottom
            left
            offset-y
            origin="top right"
            transition="scale-transition"
        >
            <template v-slot:activator="{ attrs, on }">
                <v-btn class="ml-2" min-width="0" text v-bind="attrs" v-on="on">
                    <v-badge color="red" overlap>
                        <template v-slot:badge>
                            <span>9+</span>
                        </template>

                        <v-icon>mdi-bell</v-icon>
                    </v-badge>
                </v-btn>
            </template>

            <v-list :tile="false" nav>
                <div>
                    <app-bar-item
                        v-for="(n, i) in notifications"
                        :key="`item-${i}`"
                    >
                        <v-list-item-title v-text="n" />
                    </app-bar-item>
                </div>
            </v-list>
    </v-menu>-->

        <!-- <v-btn icon> <v-icon>mdi-heart</v-icon> </v-btn> -->

        <v-menu left bottom transition="scroll-x-reverse-transition">
            <template v-slot:activator="{ on }">
                <!-- <v-btn icon v-on="on">
                    <v-icon>mdi-account-circle</v-icon>
        </v-btn>-->
                <v-avatar
                    icon
                    v-on="on"
                    class="fix-img-ava"
                    style="cursor:pointer;"
                >
                    <!-- src="https://cdn.vuetifyjs.com/images/john.jpg" -->

                    <img :src="url_pic + member.img" :alt="member.name" />
                </v-avatar>
            </template>

            <v-list class="fix-menu-appbar-color-1">
                <!-- <v-list-item
                    class="theme--light black--text"
                    v-for="n in 5"
                    :key="n"
                    @click="() => {}"
                >
                    <v-list-item-title>Option {{ n }}</v-list-item-title>
        </v-list-item>-->
                <v-row>
                    <v-col cols="12" class="text-center">
                        <v-avatar
                            icon
                            v-on="on"
                            class="fix-img-ava-2"
                            style="cursor:pointer;"
                        >
                            <!-- src="https://cdn.vuetifyjs.com/images/john.jpg" -->

                            <img
                                :src="url_pic + member.img"
                                :alt="member.name"
                            />
                        </v-avatar>
                    </v-col>
                    <v-col cols="12" class="text-center mar-t-20">
                        <span
                            style="color:#3e5f99; font-size:19px; font-family: Impact, Charcoal, sans-serif"
                            >{{ fullname }}</span
                        >
                    </v-col>
                    <v-col
                        cols="12"
                        class="text-center"
                        style="margin-top: -25px;"
                    >
                        <span style="color:#3e5f99">{{ team_name }}</span>
                    </v-col>
                    <v-col cols="12" class="text-center mar-t-10">
                        <v-btn fab x-small @click="setting()">
                            <v-icon>mdi-account-edit</v-icon>
                        </v-btn>
                        <v-btn fab x-small class="ml-2" @click="logout()">
                            <v-icon>mdi-logout</v-icon>
                        </v-btn>
                    </v-col>

                    <!-- <v-col cols="12" class="text-center mar-t-10"
                        ><v-btn rounded small @click="setting()"
                            ><span style="color:#3c6275"
                                >Manage your Account</span
                            ></v-btn
                        ></v-col
          >-->
                    <!-- <v-col cols="12" class="text-center mar-t-10">
                        <v-btn rounded small @click="logout()">
                            <span style="color:#3c6275">Sign out</span></v-btn
                        >
          </v-col>-->
                </v-row>
            </v-list>
        </v-menu>
    </v-app-bar>
</template>

<script>
import axios from "axios"
import firebaseApp from "../firebase"
import { mapState, mapMutations } from "vuex"
import _ from "lodash"

let url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    computed: {
        ...mapState(["isLoading"]),
        ...mapState(["chk_token"]),
        progress() {
            return Math.min(100, this.form.search_case.length * 10)
        },
        color() {
            return ["error", "warning", "success"][
                Math.floor(this.progress / 20)
            ]
        },
    },
    // created() {
    //     this.check_search_case = _.debounce(this.check_search_case, 2000)
    // },
    mounted() {
        this.getNum()
    },
    methods: {
        ...mapMutations(["mutateMiniSidebar"]),
        ...mapMutations(["mutateToken"]),
        ...mapMutations(["mutateIsLoading"]),
        changeMutate() {
            const isMobile = this.$vuetify.breakpoint.smAndDown
            const obj = {
                isMobile: isMobile,
                navShow: true,
            }
            this.mutateMiniSidebar(obj)
        },
        async getNum() {
            var ref = firebaseApp.database().ref("contacts")
            const val = await ref.once("value").then(function(snapshot) {
                return snapshot.numChildren()
            })

            this.numAlert = val
        },

        logout() {
            localStorage.removeItem("storagetime")
            localStorage.removeItem("fullname")
            localStorage.removeItem("token")
            localStorage.removeItem("team_name")
            localStorage.removeItem("emp_img")
            localStorage.removeItem("themes")
            localStorage.removeItem("chk_newuser")
            localStorage.removeItem("role_type")
            localStorage.removeItem("travel_mode")
            localStorage.removeItem("initials_en")
            localStorage.removeItem("initials_th")
        
            this.mutateToken()
        },
        setting() {
            this.$root.$router.push({
                path: "/Setting/",
            })
        },
        func_chk_color_bar() {
            // console.log(this.chk_color_bar)
        },
        async check_search_case() {
            if (
                this.form.search_case != "" &&
                this.form.search_case != null &&
                this.form.search_case.length >= 4
            ) {
                let searchtext = {
                    searchtext: this.form.search_case,
                }
                this.dialog_loading = true
                await axios
                    .post(url + "search-case", searchtext)
                    .then((response) => {
                        // console.log(response)
                        this.dialog_loading = false
                        this.$root.$router.push({
                            path: "/Search-Case/" + this.form.search_case,
                            query: { q: response.data },
                        })
                        if (response.data.status == "ok") {
                            this.form.search_case = ""
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        },
        async change_theme() {
            this.$vuetify.theme.dark = !this.$vuetify.theme.dark

            if (this.$vuetify.theme.dark == false) {
                localStorage.removeItem("themes")
            } else {
                localStorage.setItem(
                    "themes",
                    Boolean(this.$vuetify.theme.dark)
                )
            }

            let theme = {
                themes: this.$vuetify.theme.dark,
            }
            await axios
                .post(url + "change-theme", theme, {
                    headers: { Authorization: "Bearer " + localStorage.token },
                })
                .then((response) => {
                    // console.log(response.data, "-change-theme")
                })
                .catch((error) => {
                    console.log(error)
                })
        },
    },
    data() {
        return {
            numAlert: 0,
            notifications: ["", "Test Notification", ""],
            fullname: localStorage.fullname,
            team_name: localStorage.team_name,
            member: {
                img: localStorage.emp_img,
            },
            url_pic: `${process.env.VUE_APP_ROOT_API}/api/profile_img/`,
            chk_color_bar: true,
            on: false,
            form: {
                search_case: "",
            },
            custom: true,
            dialog_loading: false,
        }
    },
}
</script>
<style scoped>
.fix-img-ava {
    width: 35px !important;
    height: 35px !important;
}
.fix-img-ava-2 {
    width: 45px !important;
    height: 45px !important;
}
.fix-appbar-1 {
    background: linear-gradient(
        to bottom right,
        rgb(40, 79, 151),
        rgb(10, 138, 116)
    ); /* Standard syntax */
}

.fix-appbar-2 {
    background: linear-gradient(
        -90deg,
        rgb(40, 79, 151),
        rgb(10, 138, 116)
    ); /* Standard syntax */
}

.fix-appbar-3 {
    background: linear-gradient(
        to bottom right,
        rgb(46, 46, 46),
        rgb(0, 0, 0)
    ); /* Standard syntax */
}

@media screen and (min-width: 850px) {
    .v-menu__content {
        width: 22% !important;
    }
}

.fix-menu-appbar-color-1 {
    background: linear-gradient(
        to bottom right,
        rgb(190, 221, 247),
        rgb(218, 255, 244)
    ) !important;
}
.menuable__content__active {
    z-index: 200 !important;
}
</style>
